<template>
  <basic-container>
    <el-form :inline="true" ref="form"  v-if="showSearchForm" :model="query">
      <el-row>
        <el-col span="6" style="padding-left: 10px;">
          <el-form-item label="车场名称">
            <selectSearch  v-model="query.parkingLotId" :dicData="parkingLotList"></selectSearch>
            <!-- <el-select
              v-model="query.parkingLotId"
              style="width: 100%; "
              placeholder="请选择车场"
              size="small"
            >
              <el-option
                v-for="item in parkingLotList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-col>

        <el-col span="18" style="text-align:right;">
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="search">搜 索</el-button>
            <!-- <el-button type="default" size="small" icon="el-icon-delete" @click="searchReset">重 置</el-button> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"

               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="couponShopDialogOpen"
                   v-if="permission.carcouponshop_add">新 增
        </el-button>
      </template>
      <template slot="menuRight">
        <el-tooltip class="item" effect="dark" content="搜索" placement="top-start">
               <el-button style="float: right;" size="small" @click="showSearchForm = !showSearchForm" icon="el-icon-search" circle></el-button>

        </el-tooltip>
        </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.carcouponshop_edit"
          @click="couponShopEditDialogOpen(scope.row)"
        >编辑</el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          v-if="permission.carcouponshop_delete"
          @click="rowDel(scope.row)"
        >删除</el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-money"
          @click="openSendCouponsDialog(scope.row)"
        >发券详情</el-button>
      </template>
      <template slot="couponNum" slot-scope="scope">
        <span> {{scope.row.couponNum}}种</span>

      </template>
    </avue-crud>
    <el-dialog
      title="新增"
      :visible.sync="couponShopAddShow"
      :modal-append-to-body="false"
      append-to-body
      @close="couponShopDialogClose"
      width="50%"
    >
      <div class="el-dialog-div">
        <el-form ref="addForm" :rules="rules" :model="addForm" label-width="120px">
          <el-row>
            <el-col span="11">
              <el-form-item label="车场名称" prop="parkingLotId">
                <selectSearch  v-model="addForm.parkingLotId" :dicData="parkingLotList"></selectSearch>
                <!-- <el-select
                  v-model="addForm.parkingLotId"
                  placeholder="请选择车场"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in parkingLotList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="商家名称" prop="shopName">
                <el-input v-model="addForm.shopName" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item label="责任人" prop="shopResponsiblePerson">
                <el-input v-model="addForm.shopResponsiblePerson" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="手机号" prop="shopPersonPhone">
                <el-input v-model="addForm.shopPersonPhone" maxlength="11" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
         <el-row>
            <el-col span="11">
              <el-form-item label="appId" prop="appId">
                <el-input v-model="addForm.appId" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="KEY" prop="appKey">
                <el-input v-model="addForm.appKey" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <h3>创建用户</h3>
            <el-col span="22">
              <el-form-item label="添加用户" prop="shopUser">
                <el-select
                  v-model="addForm.shopUser"
                  placeholder="请选择用户"
                  size="small"
                  multiple
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in shopUseList"
                    :key="item.userKey"
                    :label="item.userLabel"
                    :value="item.userKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="24" style="text-align:right;">
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="small" @click="couponShopAddSubmit">保存</el-button>
                <el-button type="default" icon="el-icon-delete" size="small" @click="couponShopDialogClose">返回</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="couponShopEditShow"
      :modal-append-to-body="false"
      append-to-body
      @close="couponShopEditDialogClose"
      width="50%"
    >
      <div class="el-dialog-div">
        <el-form ref="editForm" :rules="editRules" :model="editForm" label-width="120px">
          <el-row>
            <el-col span="11">
              <el-form-item label="车场名称" prop="parkingLotId">
                <el-input v-model="editForm.$parkingLotId" disabled></el-input>
                <el-input v-model="editForm.parkingLotId" v-show="false"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="商家名称" prop="shopName">
                <el-input v-model="editForm.shopName" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item label="责任人" prop="shopResponsiblePerson">
                <el-input v-model="editForm.shopResponsiblePerson" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="手机号" prop="shopPersonPhone">
                <el-input v-model="editForm.shopPersonPhone" maxlength="11" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item label="appId" prop="appId">
                <el-input v-model="editForm.appId" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="KEY" prop="appKey">
                <el-input v-model="editForm.appKey" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <h3>创建用户</h3>
            <el-col span="22">
              <el-form-item label="添加用户" prop="shopUser">
                <el-select
                  v-model="editForm.shopUser"
                  placeholder="请选择用户"
                  size="small"
                  multiple
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in shopUseList"
                    :key="item.userKey"
                    :label="item.userLabel"
                    :value="item.userKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col offset="6">
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="couponShopEditSubmit">保存</el-button>
                <el-button type="default" icon="el-icon-delete" @click="couponShopEditDialogClose">返回</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <sendCoupons ref="sendCoupons"></sendCoupons>
  </basic-container>

</template>

<script>
  import { getDictionary } from '@/api/common';
  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import {
    add,
    getDetail,
    getList,
    remove,
    update,
    userList,
    syncShop,
  } from '@/api/v4ward/park/coupon/shop/carcouponshop';
  import { mapGetters } from 'vuex';
  import sendCoupons from "./send-coupons.vue";
  export default {
    components:{sendCoupons},
    data() {

      // 手机号验证
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
        if (!value) {
          return callback(new Error('电话号码不能为空'));
        }
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error('电话号码格式不正确'));
          }
        }
      };

      // 0-100数值校验
      var checkNum = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('百分比不能为空'));
        }
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error('请输入0-100数值'));
          } else {
            callback();
          }
        }
      };
      return {
        showSearchForm:true,
        query: {
          parkingLotId: '',
        },
        parkingLotList: [],
        shopUseList: [],
        shopNotifyMethodList: [],
        //新增
        couponShopAddShow: false,
        addForm: {
          parkingLotId: '',
          shopName: '',
          appId:'',
          appKey:'',
          shopResponsiblePerson: '',
          shopPersonPhone: '',
          shopLimitAmount: '',
          shopLimitNotify: '',
          shopNotifyMethod: '',
          shopUser: '',
        },
        rules: {
          parkingLotId: [
            { required: true, message: '请选择车场', trigger: 'blur' },
          ],
          shopName: [
            { required: true, message: '请输入商家名称', trigger: 'blur' },
            { max: 50, message: '优惠券名称最大长度为50字符', trigger: 'blur' },
          ],
          shopResponsiblePerson: [
            { required: true, message: '请输入责任人', trigger: 'blur' },
            { min: 2, max: 12, message: '责任人名称长度在2-12位', trigger: 'blur' },
          ],
          shopPersonPhone: [
            { required: true, validator: checkPhone, trigger: 'blur' },
          ],
          shopLimitAmount: [
            { required: true, message: '请输入限额', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (/^(?:[1-9]\d*|0)$/.test(value) == false) {
                  callback(new Error('请输入正整数'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
          shopLimitNotify: [
            { required: true, validator: checkNum, trigger: 'blur' },
          ],
          shopUser: [
            { message: '请选择用户', required: true, trigger: 'blur' },
          ],
        },
        //编辑
        couponShopEditShow: false,
        editForm: {
          $parkingLotId:'',
          parkingLotId: '',
          shopName: '',
          appId:'',
          appKey:'',
          shopResponsiblePerson: '',
          shopPersonPhone: '',
          shopLimitAmount: '',
          shopLimitNotify: '',
          shopNotifyMethod: '',
          shopUser: '',
        },
        editRules: {
          shopName: [
            { required: true, message: '请输入商家名称', trigger: 'blur' },
            { max: 50, message: '优惠券名称最大长度为50字符', trigger: 'blur' },
          ],
          shopResponsiblePerson: [
            { required: true, message: '请输入责任人', trigger: 'blur' },
            { min: 2, max: 12, message: '责任人名称长度在2-12位', trigger: 'blur' },
          ],
          shopPersonPhone: [
            { required: true, validator: checkPhone, trigger: 'blur' },
          ],
          shopLimitAmount: [
            { required: true, message: '请输入限额', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (/^(?:[1-9]\d*|0)$/.test(value) == false) {
                  callback(new Error('请输入正整数'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
          shopLimitNotify: [
            { required: true, validator: checkNum, trigger: 'blur' },
          ],
          shopUser: [
            { message: '请选择用户', required: true, trigger: 'blur' },
          ],
        },
        onLoadFlage:true,//onload执行开关
        form: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        option: {
          align: 'center',
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          stripe:true,
          dialogClickModal: false,
          column: [
            {
              label: '车场名称',
              prop: 'parkingLotId',
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              type: 'tree',
              dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
              rules: [{
                required: true,
                message: '请输入停车场ID',
                trigger: 'change',
              }],
            },
            {
              label: '商家名称',
              prop: 'shopName',
              rules: [{
                required: true,
                message: '请输入商家名称',
                trigger: 'change',
              }],
            },
            {
              label: '责任人',
              prop: 'shopResponsiblePerson',
              rules: [{
                required: true,
                message: '请输入商家责任人',
                trigger: 'change',
              }],
            },
            {
              label: '电话',
              prop: 'shopPersonPhone',
              rules: [{
                required: true,
                message: '请输入责任人手机号码',
                trigger: 'change',
              }],
            },
            {
              label: '优惠券类型',
              prop: 'couponNum',
              slot:true

            },

          ],
        },
        data: [],
      };
    },
    activated() {
      let self = this;
      setTimeout(() => {
        this.$refs.crud.doLayout(); //解决表格错位
      }, 0);
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(null, false),
          viewBtn: this.vaildData(this.permission.carcouponshop_view, false),
          delBtn: this.vaildData(null, false),
          editBtn: this.vaildData(null, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    created() {
      this.option.height = this.bodyHeight - 300;
      this.initData();
    },
    watch: {
      'showSearchForm'(val){
        this.$nextTick(() => {
            //isClickSearch :默认设置为true
              setTimeout(()=>{
                   if(val){
                      this.option.height = this.bodyHeight - 300;
                    }else{
                      this.option.height = this.bodyHeight - 260;
                    }
                  this.$refs.crud.getTableHeight();
              })
            });

      },
      'addForm.parkingLotId': function(val, oldVal) {
        if (val) {
          userList({ spaceId: val }).then(({ data }) => {
            this.addForm.shopUser = "";
            this.shopUseList = data;
          });
        }
      },
    },
    methods: {
      async initData(){
          await getSpaceTree().then((data) => {
              this.parkingLotList = data.data;
              if (this.parkingLotList.length > 0) {
                this.query.parkingLotId = this.parkingLotList[0].id;
              }
          });
          this.onLoadFlage = false;
          this.onLoad();

      },
      openSendCouponsDialog(row){
        console.log(21123)
        this.$refs.sendCoupons.openDialog({parkingLotId:this.query.parkingLotId,shopId:row.id});
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },

      rowDel(row) {
        if(row.balance > 0){
          this.$message.warning('账户余额未结清，不能删除！');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: row.id });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail({ id: this.form.id }).then(({ data }) => {
            this.form = data;
          });
        } else if ('add' === type) {
          this.cleanForm();
        }
        done();
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },
      searchReset() {
        if (this.parkingLotList.length > 0) {
          this.query.parkingLotId = this.parkingLotList[0].id;
        }
        this.onLoad();
      },
      search(){
        this.page.currentPage = 1;
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        if(this.onLoadFlage){
          return
        }
        this.loading = false;
        if(this.query.parkingLotId == ""){
          return;
        }
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query),
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }).catch(err=>{
          this.loading = false;
        })
      },
      //新增
      couponShopDialogOpen() {
        this.couponShopAddShow = true;
        //设置默认车couponShopDialogOpen场
        if (this.parkingLotList.length > 0) {
          this.addForm.parkingLotId = this.parkingLotList[0].id;
        }
        //获取提醒方式类型
        getDictionary('coupon_limit_notify_method').then((data) => {
          if (data.data.length > 0) {
            this.shopNotifyMethodList = data.data;
            this.addForm.shopNotifyMethod = this.shopNotifyMethodList[0].dictKey;
          }
        });

      },
      couponShopDialogClose() {
        this.$refs['addForm'].resetFields();
        this.couponShopAddShow = false;
        this.addForm.parkingLotId = '',
        this.addForm.shopName = '',
        this.addForm.shopResponsiblePerson = '',
        this.addForm.shopPersonPhone = '',
        this.addForm.shopLimitAmount = '',
        this.addForm.shopLimitNotify = '',
        this.addForm.shopNotifyMethod = '',
        this.addForm.shopUser = '';
        this.onLoad();
      },
      couponShopAddSubmit() {

        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            this.addForm.shopUser = this.addForm.shopUser.join(',');
            console.log('submit!!');
            add(this.addForm).then(() => {
              this.couponShopDialogClose();
              this.onLoad();
              this.$message.success('操作成功!');
            }, error => {
              window.console.log(error);
              // loading();
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //编辑
      couponShopEditDialogOpen(row) {
        this.couponShopEditShow = true;

        //设置默认车场
        this.editForm = row;
        this.editForm.shopUser = this.editForm.shopUser.split(',');
        //获取用户列表
        userList({ spaceId: this.editForm.parkingLotId }).then(({ data }) => {
          this.shopUseList = data;
        });
        //获取提醒方式类型
        getDictionary('coupon_limit_notify_method').then((data) => {
          if (data.data.length > 0) {
            this.shopNotifyMethodList = data.data;
            this.editForm.shopNotifyMethod = this.shopNotifyMethodList[0].dictKey;
          }
        });

      },
      couponShopEditDialogClose() {
        this.$refs['editForm'].resetFields();
        this.couponShopEditShow = false;
        this.editForm.parkingLotId = '',
        this.editForm.shopName = '',
        this.editForm.shopResponsiblePerson = '',
        this.editForm.shopPersonPhone = '',
        this.editForm.shopLimitAmount = '',
        this.editForm.shopLimitNotify = '',
        this.editForm.shopNotifyMethod = '',
        this.editForm.shopUser = '';
        this.onLoad();
      },
      // 编辑
      couponShopEditSubmit() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            this.editForm.shopUser = this.editForm.shopUser.join(',');
            console.log('editsubmit!!');
            update(this.editForm).then(() => {
              this.onLoad();
              this.couponShopEditDialogClose();
              this.$message.success('操作成功!');
            }, error => {
              window.console.log(error);
              loading();
            });
          } else {
            console.log('error editsubmit!!');
            return false;
          }
        });
      },


    },
  };
</script>

<style>
</style>
